module.exports = __webpack_public_path__ + "img/t4-ic1.c060ecc6.svg";